module.exports = __webpack_public_path__ + "img/97.22dba97.svg";